import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
import { Dialog, Button } from "element-ui";
Vue.use(Dialog);
Vue.use(Button);
